
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen, langtw, langydl, langpty, langjp,langar, langxby,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  "请输入您的国家":"請輸入您的國家",
  "借贷审核中":"借貸審核中",
  "完成":"完成",
  "可用贷款池":"可用貸款池",
  "直观易用的界面":"直覺易用的介面",
    "访问 3,000 多个市场":"造訪 3,000 多個市場",
    "实时更新和价格提醒":"即時更新和價格提醒",
    "各种技术指标、分析工具和高级图表":"各種技術指標、分析工具和進階圖表",
    "先进的对冲策略和综合风险管理工具":"先進的對沖策略和綜合風險管理工具",
  "操作不熟练,试试模拟交易":"操作不熟練，試試模擬交易",
  "访问我们的帮助中心,获取交易指南":"訪問我們的幫助中心，獲取交易指南",
  "希望增进您的交易技巧？":"希望增進您的交易技巧？",
  "每月提取金额":"每月提取金額",
  "交易者":"交易者",
  "亿":"億",
  "万":"萬",
  "3000多种品类供您选择":"3000多種品類供您選擇",
  "24小时交易量":"24小時交易量",
  "线上交易,请选择":"線上交易,請選擇",
  "交易所":"交易所",
  "3000多种品类,包括加密货币,贵金属,外汇, 原油等等":"3000多種品類,包括加密貨幣,貴金屬,外匯, 原油等等",
  "立即交易":"立即交易",
  "希望增进您的交易技巧":"希望增進您的交易技巧",
  "访问我们的帮助中心,获取全面交易指南":"造訪我們的幫助中心,取得全面交易指南",
  "去看看":"去看看",
  "操作不熟练,试试我们的模 拟交易功能":"操作不熟練,試試我們的模 擬交易功能",
  "免费体验交易,让您尽快上手":"免費體驗優惠,讓您盡快上手",
  "马上体验":"馬上體驗",
  "充币":"充幣",
  "提币":"提幣",
  "客服":"客服",
  "更多":"更多",
  "热门品种":"熱門品種",
  "卖出":"賣出",
  "买入":"買入",
  "了解我们的平台":"了解我們的平台",
  "直观易用":"直覺易用",
  "的界面":"的介面",
  "定期提供":"定期提供",
  "3,000多个市场":"3,000多個市場",
  "的实时更新和 价格警报":"的即時更新和 價格警報",
  "各种技术指标":"各種技術指標",
  "分析工具和高级图表":"分析工具和進階圖表",
  "套期保值模式和":"避險模式和",
  "风险管理工具":"風險管理工具",
  "我们创建了技术领先且人性化的交易平台 ,为您提供贴心完善的交易体验":"我們創建了技術領先且人性化的交易平台 ,為您提供貼心完善的交易體驗",
  "实时新闻咨询":"即時新聞諮詢",
  "紧跟我们的新闻、产品和活动信息":"緊跟我們的新聞、產品和活動訊息",
  "阅读更多新闻":"閱讀更多新聞",
  "合作伙伴等最新新闻动态":"合作夥伴等最新新聞動態",
  "AI智能赚币":"AI智能賺幣",
  "出金":"出金",
  "随存随取":"隨存隨取",
  "一键即刻取出,从不等待":"一鍵即刻取出,從不等待",
  "稳定":"穩定",
  "最稳健的理财":"最穩健的理財",
  "稳定收益,您的理财助手":"穩定收益,您的理財助手",
  "执行速度":"執行速度",
  "极速执行":"極速執行",
  "所有订单将以毫秒级别速度执行":"所有訂單將以毫秒速度執行",
  "每天发放":"每天發放",
  "当天产生收益":"當天產生收益",
  "当天购买当天产生收益,24小时及时发放收益":"當天購買當天產生收益,24小時及時發放收益",
  "现在就开始":"現在就開始",
  "交易全球金融市场":"交易全球金融市場",
  "支持桌面端与移动端多种方式,您可随时 随地开展交易":"支援桌面端與行動裝置多種方式,您可隨時 隨地進行交易",
  "谷歌下载":"Google下載",
  "下载":"下載",
  "公司":"公司",
  "关于我们":"關於我們",
  "许可证监督":"許可證監督",
  "帮助中心":"幫助中心",
  "政策":"政策",
  "条款与条件":"條款與條件",
  "隐私政策":"隱私權政策",
  "声明":"聲明",
  "法律信息":"法律資訊",
  "免责声明":"免責聲明",
  "风险警告":"風險警告",
  "关于广告":"關於廣告",
  currency: {
    bb: '幣幣交易',
    bba: '幣幣賬戶',
    hy: '合約交易',
    jg: '期權交易',
    jg1: '期貨合約',
    hya: '合約賬戶'
  },
  home:{
    user:'用使用者的共同選擇',
    start:'開始交易',
    trading:'交易產品',
    fee:'最低手續費',
    co:'合作單位',
    varieties:'交易品種',
    leading:'引領web3創新探索',
    market:'交易品種市場趨勢',
    explore:'探索無限可能',
    newcurrency:'新幣申購功能上線！',
    alimited:'新幣上線，您可以在這裡買到您覺得有潛力的新幣',
    get_start:'開始使用',
    ai_coin:'AI賺幣計畫進行中',
    ai_text:'開始AI賺幣，穩定收益，高報酬率，讓你躺著賺幣',
    loan:'贷貸款功能上線',
    loan_text:'當您沒錢的時候，您可以申請貸款，最快當天下發',
    mobile_pc:'手機PC端護士使用',
    pc_anytime:'隨時隨地開始交易：',
    pc_text:'我們提供強大的圖表分析工具：五十多種技術指標和盤面分析工具。安全可靠、易於使用的槓桿高槓桿利用的功能特點，成為線上投資的標準平台。',
    mobile_down:'點擊下載',
    mobile_android:'安卓市場',
    mobile_ios:'蘋果商店',
    open_text:'三分之一即可申請真實交易帳戶或免費體驗模擬帳戶',
    open_account:'一個帳戶',
    tocomplete:'去完成',
    walletlogin:'錢包登入'
  },
  index: {
    h24: '24H量',
    header_title: ['數位資產交易就選' + window.GLOBAL.LANG_TITLE.tw],
    header_small_title:'完整的一站式区块链数字资产交易',
    header_msg: '安全 - 穩定 - 可信',
    register_title: '註冊一個 ' + window.GLOBAL.LANG_TITLE.tw + ' 全球站賬號 開始交易旅程',
    register_pl: '請輸入你的郵箱或手機',
    register: '註冊',
    featureTitleWhy: '為什麼選擇我們',
    featureTitle: '安全 · 穩定 · 可靠',
    featureMsg: '',
    featureList: [
      { icon: icon1, title: '安全的錢包技術', msg: ['冷、熱錢包技術由全球頂級的安全團隊開發,從未發生過丟幣事件。', ''] },
      { icon: icon2, title: '豐富的加密資產業務', msg: ['支持現貨和多種衍生品交易等,是您的進入加密資產世界的貼身管家。',''] },
      { icon: icon3, title: '分布在世界各地的客戶', msg: ['為全球超過130個國家或地區用戶,提供加密資產的全方位服務。',''] }
    ],
    bannerList: [
      { icon: banner01,title: "致力於提供業內 領先安全和穩定性", msg: ["智能合約保障投資人資產安全","交易績效真實","24h服務保障"] },
      { icon: banner02,title: "我想通過簡單操作立即買進賣出", msg: ["簡單的交易畫面","立即反映在您的賬戶余額中","大多數加密貨幣都可以交易"] },
      { icon: banner03,title: "我想通過交割合約交易積極賺取利潤", msg: ["開戶同時可用", "大量交易期貨的戰略投資","一年 365 天，一天 24 小時都可以交易，即使在周末也是如此"] }
    ],
    featureList2: [
      { icon: icon1_01, title: "透明開放", msg: ["運用區塊鏈與智能合約的特性，將交易績效真實上鏈，並使用智能合約保障投資人資產安全",""] },
      { icon: icon1_02, title: "智能投資", msg: ["經由頂尖的量化交易專家所提供的多樣化策略，任您自由選擇",""] },
      { icon: icon1_03, title: "風險分級", msg: ["依據各投資人不同風險與資產管理偏好設計出多元化的投資產品，有效消除投資門檻", ""] },
      { icon: icon1_04, title: "產品多元", msg: ["提供各類型用戶投資需求及彈性的平臺機製，持續產出優於市場的創新金融服務", ""] }
    ],
    featureTitle2: '隨時隨地 多平臺終端交易',
    featureMsg2: '覆蓋iOS、Android多個平臺,支持全業務功能',
    tab: ['主流幣', '24H 漲幅榜'],
    thead: ['交易對', '最新價格', '當日最高價', '當日最低價','漲幅榜', '24H成交量', '操作'],
    more: '查看更多 >',
    btn: '交易',
    dealsTitle: '一站式交易服務',
    dealsTab:[
      { title: '幣幣交易', content: '幣幣交易是針對數字資產之間的兌換,以USDT作為計價單位去購買其他幣種 。'+window.GLOBAL.LANG_TITLE.tw+'幣幣交易支持比特幣、以太坊、萊特幣等數字資產實時交易。', src:'/static/image/deals-1.jpg', path: '' },
      { title: '合約交易', content: '壹種數字貨幣的金融衍生品,不僅支持選擇買多或賣空合約來賺取收益,而且操作簡單,永不到期。'+window.GLOBAL.LANG_TITLE.tw+'合約具有先進的風險管理系統,杠桿最高可達100倍。', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['自選', '合約', '幣幣'],
    thead: ['幣種', '最新價', '24H漲跌幅', '24H最低', '24H最高','24H成交量', '操作'],
    nodata: '暫無數據'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.tw + '. All rights reserved.',
    dd: [
      {
        dt: "關於我們",
        dd: [{ title: "公司簡介", id: 1 }, { title: "幫助中心", type: 'help' }]
      },
      {
        dt: "用戶支持",
        dd: [
          { title: "用戶協議", id: 3 },
          { title: "隱私條款", id: 5 }
        ]
      },
      {
        dt: "聯系我們",
        icon: true
      }
    ],
    terms: "條款說明",
    serve: "服務",
    product: "產品",
  },
  nav: {
    btn: ["登錄", "註冊", "資產管理","下載APP"],
    nav: [
      // { title: "首頁", path: "/index" },
      // { title: "幣幣交易", path: "/deal",name: 'deal' },
      { title: "行情", path: "/market" },
      { title: "交易", path: "/preciousMetal", name: 'preciousMetal'},
      // { title: "幣幣交易", path: "/deal" },
      // { title: "合約交易", path: "/deal_c" },
      // { title: "數字貨幣", path: "/deal_jg", name: 'deal_jg' },
      { title: "理財", path: "/profit_index",name: 'profit_index' },
      // { title: "活動", path: "/sign",name: 'sign' }
    ],
    nav2: [{ title: "我的資產", path: "/asset" }],
    menus: [
      { icon: langzh, title: "用戶中心", path: "/setting" },
      // { icon: langen, title: "交易日誌", path: "/deallog" },
      //{ icon: langzh, title: "身份認證", path: "/authentication" },
      { icon: langen, title: "退出登錄" }
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      { icon: langxby, lang: "España", key: 'es' },
      { icon: langfy, lang: "français", key: 'fr' },
      { icon: langdy, lang: "Deutsche", key: 'de' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      // { icon: langar, lang: "عربي", key: 'ar' },
      { icon: langhy, lang: "한국어", key: 'kr' },
      { icon: langty, lang: "ไทย", key: 'th' },
      { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
   { icon: langydl, lang: "Italia", key: 'it' },
      { icon: langpty, lang: "Portugal", key: 'pt' },
      // { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'tw' },
    ]
  },
  download:{
    "xz": "下載"
  },
  // 登錄
  // login: {
  //   login: '歡迎登錄',
  //   msg: '請輸入您已註冊的賬號',
  //   list: ['手機/郵箱', '密碼', '忘記密碼?', '登錄', '沒有賬號,立即註冊'],
  //   message: '賬號或密碼不能為空'
  // },
  register: {
    dl: ['手機註冊', '郵箱註冊'],
    title: '註冊账户',
    country: '國籍',
    country_info: '國籍資訊注册後不可修改，請務必如實選擇',
    account: '賬號',
    code_text: '請輸入驗證碼',
    code_btn: '獲取驗證碼',
    code_unit: 's',
    code_no_data: '驗證碼不能為空',
    password_text: '請輸入密碼',
    password_again_text: '請再次輸入密碼',
    pid_text: '邀請碼',
    pid_pl: '选填',
    invitation_code_no_data: '邀請碼必填',
    xy: '用戶協議',
    xy_no_checked: '請選擇協議',
    agree: '我已閱讀並同意',
    register_btn: '註冊',
    bz: ['國籍信息註冊後不可修改,請務必如實選擇。', '驗證郵件可能會被誤判為垃圾郵件,請註意查收。', '請妥善保存您的' + window.GLOBAL.LANG_TITLE.tw + '賬號及登錄密碼。', '請勿和其他網站使用相同的登錄密碼。'],
    account_no_data: '賬號不能為空',
    code_no_equality: '驗證碼不相等',
    password_no_data: '密碼不能為空',
    password_no_equality: '兩次密碼不相等'
  },
  // 設置密碼
  bindmpwd: {
    title: '設置密碼',
    account: '賬號',
    code_text: '請輸入驗證碼',
    code_btn: '獲取驗證碼',
    code_unit: 's',
    password_text: '請輸入密碼',
    password_again_text: '請再次輸入密碼',
    code_no_data: '驗證碼不能為空',
    code_no_equality: '驗證碼不相等',
    password_no_data: '密碼不能為空',
    password_no_equality: '兩次密碼不相等',
    bindmpwd_btn: '確認',
    phone_no_data: '手機號碼不能為空',
    password_login_text: '請輸入登錄密碼',
    password_trade_text: '密碼長度6位數字',
    password_again_tarde_text: '密碼長度6位數字',
  },
  // 忘記密碼
  forgetpwd: {
    title: ['修改密碼', '忘記密碼'],
    account: '賬號',
    code_text: '請輸入驗證碼',
    code_btn: '獲取驗證碼',
    code_unit: 's',
    password_text: '請輸入密碼',
    password_again_text: '請再次輸入密碼',

    phone_no_data: '手機號碼不能為空',

    account_no_data: '賬號不能為空',
    code_no_data: '驗證碼不能為空',
    code_no_equality: '驗證碼不相等',
    password_no_data: '密碼不能為空',
    password_no_equality: '兩次密碼不相等',
    forgetpwd_btn: '確認'
  },
  // 綁定手機號碼
  bindphone: {
    title: '綁定手機號碼',
    phone_text: '手機號',
  },
  person: {
    more: '加載更多',
    no_more: '沒有數據了',
    index_center:"用戶中心",
    index_menus: [
      { icon: zhsz, title: "賬戶管理", path: '/setting' },
      { icon: sfrz, title: "身份驗證", path: '/sfyz' },
      { icon: sfrz, title: "初級認證", path: '/smauth' },
      { icon: jtrz, title: "高級認證", path: '/seniorauth' },
      { icon: jtrz, title: "地址認證", path: '/dzrz' },
      { icon: jtrz, title: "快捷買幣", path: '/kjmbSelect' },
      { icon: jtrz, title: "信用分", path: '/credit' },
      { icon: jtrz, title: "賬戶記錄", path: '/deallog' },
      { icon: jtrz, title: "充幣記錄", path: '/cbjl' },
      { icon: jtrz, title: "提幣記錄", path: '/tbjl' },
    ],
    cbtb: '充幣提幣',
    jymx: '交易明細',
    xyf: {
      'title': '信用分',
      'pgsj': '評估時間'
    },
    smrz:{
      title:'實名認證',
      sure_title:'您已通過實名認證',
      zj_type:'證件類型',
      zj_info:['1、認證資訊一經驗證不可修改,請務必如實填寫','2、被認證的實名資訊不能重複認證'],
      zj_name:'姓名',
      zj_num:'證件號碼',
      zj_btn:'確定',
      zj_rebtn:'重新驗證',
      zj_sebtn:'高級驗證',
      zj_type_array:[{name:'身份證',type:'idcard'}],
      idCardArr: [
        {
            id: 1,
            name: "身份證"
        },
        {
            id: 2,
            name: "護照"
        },
        {
            id: 3,
            name: "駕駛證"
        },
        {
            id: 4,
            name: "居留證"
        },
        {
            id: 5,
            name: "其它"
        }
      ],
      zj_data:{city:'國籍不能為空',type:'證件類型不能為空',name:'姓名不能為空',zj_num:'證件號碼不能為空'},
      zsxm: '真實姓名',
       qsrzsxm: '請輸入真實姓名',
       zjlx: '證件類型',
       qxzzjlx: '請選擇證件類型',
       sfz: '身份證',
       zjhm: '證件號碼',
       qsrzjhm: '請輸入證件號碼',
       sczjz: '上傳證件照',
       zjzm: '上傳證件正面照',
       zjfm: '上傳證件背面照',
       qsczjzm: '請上傳證件正面照',
       qsczjfm: '請上傳證件背面照',
       scqmz: '上傳證件與個人簽名照',
       qscscqmz: '請上傳證件與個人簽名照',
       zj: [
         {
           id: 1,
           title: '身份證'
         },
         {
           id: 2,
           title: '護照'
         },
         {
           id: 3,
           title: '其他'
         },
       ],
       tj: '提交',
       shz: '審核中',
       shtg: '審核通過'
      },
      gjrz:{
      title:'高級認證',
      zj_info:['1、支持小於8M的JPG、JPEG或PNG格式圖片。','2、證件照片要求清晰,不允許任何修改和遮擋,必須能看清人像、證件號和姓名。','3、照片需免冠,建議未化妝,手持證件人的五官清晰可鑒,完整露出手臂'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

      },
      zhgl:{
      title:'安全設置',
      bind:[{bind_title:'重置密碼',bind_name:'郵箱'},{bind_title:'設置交易密碼',bind_name:'郵箱'}]

      },
      wdtg:{
              own_code:'專屬邀請碼',
              own_code_url:'專屬邀請連接',
              own_push_title:'我的推廣',
              own_push_content:['邀請總收入（估值）','邀請人數','人'],
              own_push_content_profit:['一級邀請收益','二級邀請收益','三級邀請收益','四級邀請收益'],
              own_push_content_num:['一級邀請人數','二級邀請人數','三級邀請人數','四級邀請人數'],
              own_push_profit_title: ['ID', '收益', '備註信息','添加時間'],
              own_push_num_title: ['ID', '名稱', '電話','添加时间'],

      },
    jyzt_td: ['時間', '詳情', '金額'],
    cbjl_td: ['時間', '幣種', '數量','狀態'],
    sfrz_txt: ['身份認證', '您已經提交稽核請等待結果', '您已通過高級認證', '身份證正面', '身份證反面', '認證','認證失敗,請重新認證'],

    zhsz_txt: ['您的賬號安全等級: #', '您的賬號安全等級: #,完善更多資料,保證賬號安全'],
    zhsz_m: '強',
    zhsz_n: '弱',
    zhsz_p: '不安全',
    zhsz_detailList: [
      // { icon: iconchecked, title: '我的邀請碼', value: '', btn: '復制邀請碼', class: 'copy', event: 'copy' },
      // { icon: '/static/image/User_Center-email.png', title: '邮箱', value: '用於登入、提幣、安全設置時使用',value2:'', btn: '绑定', btn2: '去绑定', path2: '/bindphone' },
      // { icon: '/static/image/User_Center-phone.png', title: '手機', value: '用於提現，修改密碼，安全設置時用以收取驗證簡訊', value2:'',btn: '绑定', btn2: '去綁定', path2: '/bindphone' },
      { icon: '/static/image/User_Center-password.png', title: '登錄密碼', value: '互聯網賬號存在被盜風險,建議您定期更改密碼以保護賬號安全。', value2:'',btn: '修改', bind_email:'請先綁定郵箱或者手机',path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: '交易密碼', value: '設置交易密碼', btn: '去設置', path: '/bindmpwd' }
    ],
    sksz_txt: ['收款設置', '保存'],
    sksz_list: [
      { label: "用戶名:", pl: "請輸入用戶名", key: "name" },
      { label: "開戶行名稱:", pl: "請輸入開戶行名稱", key: "bank_name" },
      { label: "銀行卡號:", pl: "請輸入銀行卡號", key: "bank_number" },
      { label: "支付寶賬號:", pl: "請輸入支付寶賬號", key: "alipay_account" },
      { label: "微信昵稱：", pl: "請輸入微信昵稱", key: "weixin_nickname" },
      { label: "微信賬號：", pl: "請輸入微信賬號", key: "weixin_account" }
    ]
  },
  pasination: {
    first: '首頁',
    prev: '上一頁',
    next: '下一頁',
    last: '尾頁',
    no_data: '暫無數據',
  },
  asset: {
    title: '我的資產',
    zjhz: '資金劃轉',
    cb: '充幣',
    gz: 'USDT估值',
    atnv: [],
    zh_title: '總資產折合：',
    index_title: '資產',
    address_title: '幣種',
    address_txt: ['請選擇', '提幣地址', '請輸入內容', '備註', '地址列表'],
    address_btn: ['添加', '保存', '刪除', '編輯'],
    address_td: ['幣種', '提幣地址', '備註', '操作'],
    currency_td: ['幣種', '可用', '凍結', '折合'],

    table_title: '總資產：',
    table_address_title: '提幣地址管理',
    table_td: ['幣種', '可用', '凍結', '折合', '操作'],
    table_btn: ['充幣', '提幣', '記錄', '劃轉'],

    money_text: ['提幣地址', '請選擇', '數量', '可用：', '手續費',
      '到賬數量', '交易密碼','標簽(Memo)','最低提幣 '],
    money_btn: '提幣',
    xzbz: '選擇幣種',
    money_msg: ['溫馨提示', '請勿向上述地址充值任何非USDT資產,否則資產將不可找回。', 'USDT充幣僅支持simple send的方法,使用其他方法（send all）的充幣暫時無法上賬,請您諒解。'],

    recharge_title: '充值地址',
    recharge_btn: ['復制', '二維碼', '充幣'],
    recharge_text: ['數量', '溫馨提示', '請勿向上述地址充值任何非USDT資產,否則資產將不可找回。', 'USDT充幣僅支持simple send的方法,使用其他方法（send all）的充幣暫時無法上賬,請您諒解。', '憑證', '憑證描述(選填)','链名称'],

    record_title: '財務記錄',
    record_td: ['數量', '記錄', '時間'],

    transfer_title: '劃轉',
    transfer_btn: ['全部', '轉賬'],
    transfer_text: ['從', '至', '請輸入劃轉數量', '可用：'],
    "bq": "標簽(Memo)",
   "qsrbq":"請輸入標簽",
   "yhktx":"銀行卡提現",
   "yhmc": "銀行名稱",
   "qsryhmc": "請輸入銀行名稱",
   "yhzh": "銀行賬號",
   "qsryhzh":"請輸入銀行賬號",
   "gjhkdm": "國際匯款代碼",
   "qsrgjhkdm":"請輸入國際匯款代碼",
   "yhdz": "銀行地址",
   "qsryhdz":"請輸入銀行地址",
   "skrxm": "收款人姓名",
   "qsrskrxm":"請輸入收款人姓名",
   "skrdh": "收款人電話",
   "qsrskrdh":"請輸入收款人電話",
   "skrdz": "收款人地址",
   "qsrskrdz":"請輸入收款人地址"
  },
  text: {
    btn: '返回',
    login: '請先登錄'
  },
  deal: {
    chooseType: '委托類型',
    choose: '請選擇',
    balance: '余額：',
    account: ['賬戶', '可用', '/凍結', '劃轉'],
    dir: ['買', '賣'],
    dir2: ['可買', '可賣'],
    sxf: '手續費率',
    jye: '交易額',
    cs: '自選',
    sc_list: ['市場', '幣對', '漲幅'],
    sc_h: ['當前價格', '24H最低價', '24H最高價', '24H成交量'],
    td_lt: ['幣種', '最新價', '漲幅'],
    k_line_txt: ['≈', '', '漲幅', '最高價', '最低價', '24H量'],
    tabListLTitle: ["當前委托", "歷史委托"],
    tabListLEntrust: ["買入", "賣出"],
    tabListRTitle: ["限價交易", "市價交易"],
    table_btn: ['撤單'],
    index_td_l: ['時間', '交易對象', '數量', '價格', '操作'],
    index_td_r: ['最新價', '方向', '價格', '數量'],
    index_td_r2: ['最新交易', '時間', '價格', '交易量'],
    table_txt: ['已完成', '已撤單'],

    db_1_txt: ['可用', '買入價', '賣出價', '買入量', '賣出量', '交易額', '以市場最優價格買', '以市場最優價格賣','買入手', '賣出手'],
    db_2_txt: ['價格', '杠桿', '請選擇', '手數', '1手 = ', '手', '合約市值', '保證金', '以市場最優價格買', '以市場最優價格賣'],
    pathList: ['合約記錄', '交易記錄'],
    db_btn: ['買入(做多)', '賣出(做空)'],
    tabListLTitle2: ['當前委托'],

    lt_btn: ['一鍵平倉', '設置止盈止損價', '平倉', '立即提交', '返回'],
    lt_txt: ['風險率：', '持倉總盈虧：'],
    lt_td: ['類型', '杠桿倍數', '持倉價', '當前價', '保證金', '止盈價', '止損價', '開倉時間', '手數', '盈虧', '操作'],
    lt_dl: ['設置止盈止損價', '止盈價', '止損價'],

    lt_0_btn: ['撤單'],
    lt_0_td: ['聯系方式', '幣種', '數量', '當前價', '手續費', '操作'],

    lt_1_btn: ['平倉'],
    lt_1_txt: ['平倉中'],
    lt_1_td: ['類型', '持倉價', '當前價', '保證金', '止盈價', '止損價', '開倉時間', '手續費', '盈虧', '操作'],
    node_data: '暫無數據',

    lt_3_txt: ['已平倉', '爆倉'],
    lt_3_td: ['類型', '手數', '持倉價', '平倉價', '止盈價', '止損價', '保證金', '可用保證金', '開倉時間', '平倉時間', '手續費',
      '盈虧', '操作'],

    lt_4_txt: ['已撤單'],
    cm: ['發行時間', '發行總量', '流通總量', '總湊價格', '官網','白皮書','介紹'],
    qsrsl: '請輸入數量',
    qsrss: '請輸入手數',
  },
  notice:{
      notice_title:'公告中心',
  },
  bzhl:{
    title: 'AI理財',
    title1: 'AI量化',
    ttzbt: '天天賺不停',
    wdtg: '我的托管',
    zztgdzj: '正在托管的資金',
    yjjrsy: '預估日收益',
    ljsy: '累計收益',
    tgzdd: '托管中訂單',
    tgdd: '托管訂單',
    t1: '低風險穩健理財，有需要可隨時贖回',
    t2: '您的閑錢管理小助手',
    cljxcp: '產品周期',
    dbxe: '單筆限額',
    rsyl: '日收益率(%)',
    rsyl2: '日收益率：',
    zq: '周期',
    qmr: '去買入',
    ckgd: '查看更多',
    cpgk: '產品概況',
    pxsj: '派息時間',
    tgzj: '托管資金',
    tqsh: '提取贖回',
    cpld: '產品亮點',
    cpgz: '產品規則',
    cont: '搬磚是通過將USDT托管給平臺，由平臺的專業團隊進行搬磚權利，參與者在資金托管期間可獲得平臺的搬磚收入分成，可隨時存取，安全又便捷。',
    zj: '100%資金',
    aqbz: '安全保障',
    jjrsy: '節假日收益',
    bjd: '不間斷',
    cgcrh: '成功存入後',
    dtqx: '當天起息',
    ljzr: '立即轉入',
    xqglgj: '閑錢管理工具',
    ddh: '訂單號',
    tgje: '托管金額',
    tgsj: '周期天數',
    yhl: '已獲利/剩余天數',
    xdsj: '下單時間',
    zt: '狀態',
    fh: '返回',
    qrnhsy: '七日年化收益',
    ygy: '1個月',
    bn: '半年',
    yn: '1年',
    yuan: '元',
    tzfx: '投資風險',
    shsc: '贖回時長',
    di: '低',
    yggzr: '一個工作日',
    msgsxf: '免申購手續費',
    mr: '每日',
    dqfh: '到期返還',
    ljgm: '立即購買',
    tgz: '托管中',
    sh: '贖回',
    ywc: '已完成',
    ysh: '已贖回',
    all: '全部',
    "xzbzts": "簡單，安全。可選擇多種幣種進行派息",
    "qtbz": "其它幣種"
  },
  pay:{
    qsrjymm: '請輸入6位交易密碼',
    tbmmts: '請到用戶中心設置交易密碼',
  },
  tips:{
    qxztbdz: '請輸入提幣地址',
    qsrtbsl: '請輸入提幣數量'
  },
  statusText: ['失敗','等待處理','成功'],
  dzrz: {
    title: '地址認證',
    sdddz: '水電單地址',
    zdtpsc: '賬單圖片上傳',
    qsrsdddz: '您需要填寫地址信息和提交水電費或者寬帶地址的賬單',
    qsczdtp: '請上傳賬單圖片'
  },
  jgcc: {
    wtgd: '委托掛單',
    cj: '成交',
    jj: '簡介',
    zc: '在持',
    lszc: '歷史持倉',
    qblx: '全部類型',
    xj: '現價',
    sj: '時間',
    fx: '方向',
    jg: '價格',
    sl: '數量',
    jgsj: '交割時間',
    gmj: '購買價',
    jsj: '結算價',
    yk: '盈虧',
    xq: '詳情',
    mz: '買漲',
    md: '買跌',
    dqye: '當前余額',
    gb: '關閉',
    jxxd: '繼續下單',
    qrxd: '確認下單',
    ddqr: '訂單確認',
    sxf: '手續費',
    kyye: '可用余額',
    jypz: '交易品種',
    jyfx: '交易方向',
    tzje: '投資金額',
    tzjeTips: '投資金額不能為0',
    dqsj: '到期時間',
    jssj: '結算時間',
    gmsj: '購買時間',
    sy: '收益',
    zxje: '最小數量 ',
    shi: '時',
    fen: '分',
    miao: '秒',
    zdje: '最大數量 ',
    qsrje: '請輸入金額',
    zxtzje: '最低數量 ',
    yebz: '余額不足',
    xq: '詳情',
    ddz: '等待中',
    jgjl: '交割記錄',
    bz: '幣種',
    cz: '操作'
  },
  kjmb: {
    title: '快捷買幣',
    fzcg: '復製成功',
    ljmb: '立即買幣',
    lxkf: '聯系客服'
  },
  news: {
    title: '我的消息',
    "gg": "公告",
    ckxq: '查看詳情'
  },
  statusTabs:['掛單中', '交易中','已平倉', '已撤單'],
  "chongzhi":{
    "zy": "註意",
    "cbxx": "充幣信息",
    "qsrsl": "請輸入充幣數量",
    "tips2": "1.錢包/平臺的兼容：即對該網絡支持；如目標平臺不支持您的提幣網絡，將導致資產無法找回。",
    "tips3": "2.您充值網絡和目標平臺是一致的；如您選擇了目標地址是以太坊網絡，但充值選擇了TRC20智能鏈，您或將無法找回您的數字資產。",
    "tips4": "3.充值前確保您的地址、金額正確。",
    "tips5": "溫馨提示：由於區塊網絡匿名和私密，一旦輸入錯誤信息，您將損失對應資產。請務必仔細核對您的充值地址及數量",
    "tips2_1": "• 請勿向上述地址充任何非本幣種資產，否則資產不可找回。",
    "tips2_2": "• 數字貨幣無法及時到賬，實際到賬時間取決於區塊鏈確認速度。",
    "tips2_3": "• 您的充值地址不會經常改變，可以重復充值；如有更改，我們會盡量通過網站公告或郵件通知您。",
  },
  "tibi":{
    "tbxx":"提幣信息",
    "qsrbq": "請輸入標簽",
    "tbTips1": "• 為保障資金安全，當您賬戶安全策略變更、密碼修改、我們會對提幣進行人工審核，請耐心等待工作人員電話或郵件聯系。",
    "tbTips2": "• 請務必確認電腦及瀏覽器安全，防止信息被篡改或泄露。",
    "tbTips3": "• 您所提的數字資產為一幣多鏈資產，無論您選擇從哪個鏈上提出，均意味著您所擁有的該提幣頁面展示的數字資產總量減少相應的提出數量。",
  },
  "gjlb": "國家列表",
  "qxzgjlb": "請選擇國家/地區",
  "mbwt":{
    "title": "密保問題設置",
    "mbwt": "密保問題",
    "problem":[
      {
        "id": 1,
        "title": "您小時候最好的朋友是？"
      },
      {
        "id": 2,
        "title": "您的偶像是？"
      },
      {
        "id": 3,
        "title": "您最向往的地方是哪裏？"
      }
    ],
    "qtxda": "請填寫答案",
    "qsrxmm": "請輸入新密碼",
    "qqrmm": "請確認密碼",
    "sydqmmcz": "使用當前密碼重置",
    "zhmm": "密保問題找回密碼",
    "ysz": "已設置",
    "tg": "跳過",
  "tj": "提交",
  "zyts": "重要提示：",
  "zytsCont": "請勿泄露密保答案和驗證碼，並牢記密保問題，這將有助於您找回密碼"
  },
  "zc":{
    "zclb": "資產列表",
    "zczh": "資產折合",
    "yczc": "隱藏為0的資產"
  },
  "indexNew":{
    "t1": "全球領先的",
    "t2": "數字資產服務平臺",
    "t3": "完整的一站式區塊鏈數字資產交易",
    "t4": "手機號/郵箱",
    "t5": "立即註冊",
    "t6": "歡迎世界各地的客戶通過 MFTG",
    "t7":"發現並開始他們的加密之旅"
  },
  "newReg":{
    "dl": ['郵箱','手機'],
    "cjzh": "創建賬戶",
    "sysjhzyx": "使用手機號/電子郵箱註冊",
    "yhxy": "《用戶協議》",
    "yhxy2": "我已閱讀並同意《用戶協議》",
    "yxgz": "輸入的郵箱不符合規則",
    "dhgz": "輸入的手機號碼格式有誤"
  },
  "indexNew2":{
    "t1": "在我們的訂單上交易",
    "t2": "使用比特銀行",
    "t3": "比特銀行是一種設計巧妙的比特幣和加密資產交換，非常簡單、方便、安全且功能強大。在多個web和智能手機平臺上支持交易。交易數據和圖表實時更新，為全面    市場價格分析提供60多種技術分析工具。開始交易",
    "ksjy": "開始交易",
    "ly": "選擇Bitbank的5個理由",
    "item1_t1": "交易量領先",
    "item1_t2": "No.1 * 加密資產交易量",
    "item1_t3": "高流動性，舒適（愉快的交易體驗）交易。列出 12 種加密資產。",
    "item2_t1": "第三方評價高",
    "item2_t2": "安全的交易環境",
    "item2_t3": "采用離線冷錢包。通過 Multisig 將黑客拒之門外。以高科技保護您的資產",
    "item3_t1": "易於使用且可靠的應用程序",
    "item3_t2": "易用簡便的應用程序",
    "item3_t3": "具有豐富功能的可靠應用程序。可在外交易保持交易機會。",
    "item4_t1": "全日無休",
    "item4_t2": "可入金",
    "item4_t3": "24 小時存款支持，包括假期！",
    "item5_t1": "智能手機和PC",
    "item5_t2": "人性化設計",
    "item5_t3": "即使使用智能手機也可以毫不猶豫地進行簡單合格的交易",
    "aqkk": "安全可靠",
    "aqkk2": "比特銀行的比特幣交易",
    "cjzh": "創建一個賬戶",
  },
  "xbsg":{
    "title": "新幣專區",
    "wdsg": "我的申購",
    "scts": "鎖倉天數：",
    "sy": "剩余",
    "ljsg": "立即申購",
    "ysk": "已售空",
    "xzjdy": "現在就訂閱",
    "dy": "訂閱",
    "fxjg": "發行價格",
    "fxl": "發行量",
    "ssrq": "上市日期",
    "yxqx": "有效期限",
    "qsrsl": "請輸入數量",
    "syl": "剩余量",
    "sgrq": "申購日期",
    "sgsl": "申購數量",
    "bz": "幣種",
    "yebz": "USDT余額不足",
    "tgsl": "通過數量",
    "shz": "審核中",
    "wtg": "未通過",
    "ytg": "已通過"
  },
  "wydb":{
    "title": "我要貸幣",
    "db": "貸幣",
    "dbz": "貸幣中",
    "jl": "貸款記錄",
    "jdzq": "借貸周期(天)",
    "qhk": "去還款",
    "ljdb": "累計貸幣(usd)",
    "dhkbs" :"待還款",
    "jkje": "借款金額(usdt)",
    "qsrje": "請輸入金額",
    "rll": "日利率",
    "hkfs": "還款方式",
    "dqych": "到期一次還本息",
    "lx": "利息",
    "fkjg": "放款機構",
    "tpsc": "信用貸款(圖片上傳)",
    "fwxx": "房屋信息",
    "srzm": "收入證明(雇傭關系)",
    "yhmx": "銀行明細",
    "zjz": "證件照",
    "yd": "本人已閱讀並同意",
    "xy": "申請貸幣協議",
    "sqdb": "申請貸款",
    "gb": "關閉",
    "qd": "確定",
    "ts": "請勾選申請貸幣協議",
    "dbjl": "貸幣記錄",
    "hkhth": "貸款合同號",
    "wsh": "未審核",
    "yfk": "已放款",
    "sqrq": "申請日期",
    "zq": "周期",
    "dbsl": "貸幣數量",
    "zhke": "總還款額",
    "yhke":"已還款額",
    "yhkxq": "應還款詳情",
    "bqyhk": "本期應還款（USDT）",
    "hktips": "請確保余額充足，余額不足請先充值再還款",
    "bj": "本金",
    "jie": "借",
    "ljhk": "立即還款",
    "qcz": "去充值",
    "yebzqxcz": "余額不足，請先充值再還款",
    "znj": "滯納金",
    "yqts": "逾期天數"
  },
  "hkxq":{
    "dd":"訂單",
    "fzhkdz":"復製還款地址",
    "hkxq": "還款詳情",
    "zlx": "總利息",
    "zhk": "總還款",
    "hkjg": "還款機構",
    "qschkpz": "請上傳還款憑證",
    "hkpz": "還款憑證"
  },
  "bbjyNew":{
    "jylx": "交易類型",
    "jyze": "交易總額"
  },
  "bind":{
    "title": "郵箱認證",
    "ybd": "已綁定",
    "wbd": "未綁定",
    "ts": "為保護您的賬戶，建議綁定郵箱",
    "qsryxdz": "請輸入郵箱地址"
  },
  "tipsNew": {
    "yjj": "已拒絕",
    "shz": "贖回中"
  },
  "newIndex2":{
    "zxhy": "最新行情",
    "jypt": "交易平台",
    "ssyc": "收縮隱藏",
    "hwzc": "還未註冊？",
    "ljzc": "立即註冊，發現大量機會！",
    "yyzh": "已有帳號？",
    "hjbj": "有帳號就登錄吧，好久不見了！",
    "lmdh": "欄目導航",
    "ghdjy": "更好的交易   更好的生活",
    "ghdjy02": "世界上最具創新性的加密交易中心就在這裡，您可以購買、交易和賺取加密貨幣，觸手可及的加密貨幣多達數百種。",
    "indexCont01": "一直在你身邊",
    "indexCont02": "使用先進的資金選擇、閃電般的快速執行和深度流動性交易我們的現貨和保證金市場。",
    "indexCont03": "強大的 API",
    "indexCont04": "使用我們直觀的 API、交易平台和高級訂單選項輕鬆管理您的頭寸。",
    "indexCont05": "優質數字資產",
    "indexCont06": "9年0事故",
    "indexCont07": "頂級安全風控",
    "indexCont08": "槓桿高達25 倍",
    "indexCont09": "以高達 25 倍的槓桿率交易比特幣差價合約。",
    "indexCont010": "安全儲備金",
    "indexCont011": "深度流動性",
    "indexCont012": "我們先進的專有多市場訂單技術可增強流動性、收緊點差並減少滑點。",
    "indexCont013": "用戶首選",
    "indexCont014": "覆蓋國家",
    "indexCont015": "我們的優勢",
    "indexCont016": "使用先進的資金選擇、閃電般的快速執行和深度流動性交易我們的現貨和保證金市場。",
    "indexCont017": "安全存儲",
    "indexCont018": "我們結合使用冷錢包和多方計算 (MPC) 技術來管理數字資產。",
    "indexCont019": "安全第一",
    "indexCont020": "我們使用最新技術來確保您的資金安全，並在漏洞和利用嘗試之前保持領先。",
    "indexCont021": "快速取款",
    "indexCont022": "使用多方計算，我們能夠提供快速的全天候提款，同時保持我們嚴格的安全標準。",
    "indexCont023": "購買、出售加密貨幣",
    "indexCont024": "加入全球最全面、最安全的交易平台",
    "indexCont025": "使用法定貨幣或加密貨幣買賣比特幣、以太坊、XRP 和許多其他加密貨幣。",
    "yqwj": "1000萬+",
    "dlzc": "登錄註冊",
    "yzm": "驗證碼",
    "qrmm": "確認密碼"
  },
  "langNew2":{
    "flzq": "福利專區",
    "qdjl": "簽到獎勵",
    "mrqdjl": "每日簽到獎勵",
    "qd": "簽到",
    "yqd": "已簽到",
    "hdgz": "活動規則",
    "qdjl2": "簽到記錄",
    "qdcg": "簽到成功",
    "yhd": "已獲得",
    "lq": "領取",
    "dyt": "第一天",
    "det": "第二天",
    "dst": "第三天",
    "dsit": "第四天",
    "dwt": "第五天",
    "dlt": "第六天",
    "dqt": "第七天",
    "jxz": "進行中",
    "cjxnzh": "創建虛擬賬戶",
    "sy":"首頁",
    "sc":"市場",
    "sclb":"市場列表",
    "jy":"交易",
    "zh":"帳戶",
    "db":"貸幣",
    "zchm":"註冊號碼",
    "cp":"產品",
    "tzjd":"投資借貸",
    "zxzc":"線上支援",
    "xd":"下單",
    "zzjptgmnr":"投資未來，在公平開放的金融體系中增加您的投資組合。",
    "yy":"應用程式",
    "pqnr":"摒棄傳統規則的行動銀行，為您提供精確的財務管理工具。",
    "jiami":"加密",
    "tgnr":"透過使用加密貨幣進行存款，可以獲得額外的安全層，並確保快速交易處理。",
    "jyl":"平均24小時成交量",
    "ssjmhb":"上市加密貨幣",
    "zchy":"註冊用戶",
    "djxz":"點下載",
    "azsc":"安卓市場",
    "pgsd":"蘋果商店",
    "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
  },
  // "langNew":{
  //   "szhb": "數字貨幣",
  //   "gjs": "貴金屬",
  //   "yy": "原油",
  //   "jy": "交易",
  //   "jmhb": "加密貨幣",
  //   "yxhy": "永續合約",
  //   "gdjy": "掛單交易",
  //   "khh": "開戶行",
  //   "qsrkhh": "請輸入開戶行",
  //   "yhkh": "銀行卡號",
  //   "qsryhkh": "請輸入銀行卡號",
  //  },
   "login":{
     login: '歡迎登錄',
     msg: '請輸入您已註冊的賬號',
     list: ['手機/郵箱', '密碼', '忘記密碼?', '登錄', '沒有賬號,立即註冊'],
     message: '賬號或密碼不能為空',
     "cdlks":"讓我們從登陸開始吧！",
     "zh":"帳號",
     "qsrzh":"請輸入帳號",
     "mm":"密碼",
     "qsrmm":"請輸入密碼",
     "dl":"登入",
     "wjmm":"忘記密碼",
     "qbdl":"錢包登陸",
     "myzh":"我沒有帳號?",
     "zc":"註冊",
     "yzm":"驗證碼",
     "qsryzm":"請輸入驗證碼",
     "hqyzm":"取得驗證碼",
     "qrmm":"確認密碼",
     "qsrqrmm":"確認密碼",
     "lcmmbyz":"兩次密碼輸入不一致",
     "mmts":"密碼長度6-12位元",
     "sjtx":"手機號碼格式有誤",
     "yxts":"信箱格式有誤",
     "qr":"確定",
     "sjzc":"手機註冊",
     "sjh":"手機號碼",
     "qsrsjh":"請輸入手機號碼",
     "yqm":"邀請碼(選填)",
     "qsryqm":"請輸入邀請碼",
     "yxzc":"信箱註冊",
     "wyydbzx":"同意",
     "yhxy":"《用戶服務協議》",
     "yhxy2":"使用者服務協定",
     "ysyx":"《隱私權保護協議》",
     "yx":"信箱",
     "qsryx":"請輸入信箱",
     "yxgsbzc":"信箱格式有誤",
     "cjmnzhcg":"模擬帳號建立成功",
     "tcmnzh":"退出模擬帳號",
     "qbdlts":"請用DAPP錢包App訪問",
     },
  //    "index":{
  //    "xgnysx":"新功能已上線！",
  //    "hyld":"歡迎來到我們屢獲殊榮的金融交易平台,與全球投資者一起探索未來的金融世界",
  //    "symncz":"使用模擬帳號操作",
  //    "zdjyfy":"最低交易費用 <0.3%",
  //    "jysyzc":"在一個地方交易所有資產",
  //    "hbsp":"外匯、加密貨幣、股票、指數、商品",
  //    "ksjy":"開始",
  //    "jdewd":"簡單而穩定",
  //    "aizb":"黃金AI智能交易",
  //    "srjh":"一鍵建立您的收入計畫",
  //    "kssy":"開始使用",
  //    "dlyhggdje":"低利率和更高的金額",
  //    "jmhbdk":"加密貨幣貸款",
  //    "zmyrhdyp":"在沒有任何抵押品的情況下借用加密貨幣現貨",
  //    "gs":"公司",
  //    "gywm":"關於我們",
  //    "xkzjd":"許可證監督",
  //    "bzzx":"幫助中心",
  //    "zhengce":"政策",
  //    "tkytj":"條款與條件",
  //    "yszc":"隱私權政策",
  //    "sm":"聲明",
  //    "flxx":"法律資訊",
  //    "mzsm":"免責聲明",
  //    "fxjg":"風險警告",
  //    "gygg":"關於廣告",
  //    "gg":"公告"
  //    },
     "hq":{
     "wh":"外匯",
     "szhb":"加密貨幣",
     "gp":"股票",
     "zs":"指數",
     "eft":"ETF",
     "mc":"名稱",
     "xs":"24小時%",
     "tb":"圖表",
     "jg":"價格",
     },
     "user":{
     "wdzh":"我的帳戶",
     "zh":"帳戶：",
     "dk":"貸款：",
     "sydbzj":"使用的保證金：",
     "yqll":"預期利潤：",
     "qtgn":"其他功能",
     "cz":"儲值",
     "tx":"提現",
     "dh":"兌換",
     "zhyz":"KYC認證",
     "zhjl":"帳戶記錄",
     "yqhy":"邀請好友",
     "flzq":"福利專區",
     "ggmm":"更改密碼",
     "sz":"設定",
     "cjwtjd":"常見問題",
     "fzdz":"複製位址",
     "sl":"數量...",
     "qsrsl":"請輸入數量",
     "dd":"得到(USDT)：",
     "sczm":"上傳憑證",
     "qsczm":"請上傳憑證",
     "tj":"提交",
     "czjl":"儲值記錄",
     "ddh":"訂單號碼",
     "wsh":"未審核",
     "ywc":"已完成",
     "bz":"名稱：",
     "sl2":"數量：",
     "sj":"時間：",
     "srsl":"輸入數量...",
     "dd2":"得到：",
     "qskgzflhd":"請隨時關注福利活動，我們將不定期發布",
     "hdlb":"活動列表",
     "ckxq":"查看詳情",
     "wdjl":"我的獎勵",
     "yiji":"一級",
     "erji":"二級",
     "sanji":"三級",
     "je":"金額",
     "sj2":"時間",
     "yyxz":"語言選擇",
     "tcdl":"登出登入",
     "je2":"金額(美元)...",
     "qsrje":"請輸入金額",
     "jsdz":"接收位址...",
     "qsrjsdz":"請輸入接收位址",
     "sjdz":"實際到帳：",
     "sxf":"手續費：",
     "txsm1":"提款需要5%的手續費,這需要由網路節點確認,才能記入",
     "txsm2":"請不要將加密貨幣轉讓給陌生人",
     "tz":"通知",
     "wdyq":"我的邀請",
     "yhid":"用戶ID",
     "hdjl":"獲得USD獎勵",
     "yqsm":"邀請您的好友參與Ai量化，租用礦機，產品交易，即可獲得加密貨幣獎勵",
     "yqsy":"邀請收益",
     "yqrs":"邀請人數",
     "tgljyq":"透過連結邀請",
     "lj":"連結",
     "yqm":"邀請碼",
     "cbtb":"充幣提幣",
     "jymx":"交易明細",
     "yqhyjl":"邀請好友獎勵",
     "aidd":"黃金智能交易訂單",
     "jdls":"借貸歷史",
     "etfdd":"ETF訂單",
     "jmhbdd":"加密貨幣訂單",
     "whdd":"外匯訂單",
     "gpdd":"股票訂單",
     "qx":"取消",
     "zc":"資產",
     "zzc":"總資產",
     "ky":"可用",
     "zh2":"折合（USD）",
     "xzbz":"選擇：",
     "sztkts":"提示：請到安全中心設定交易密碼",
     "jymm":"交易密碼",
     "szjymm":"設定交易密碼",
     "qsrjymm":"請輸入交易密碼",
     "zdsl":"最低數量",
     "bq":"標籤(Memo)",
     "qsrbq":"請輸入標籤",
     "yhktx":"銀行匯款",
     "yhmc":"銀行名稱",
     "qsryhmc":"請輸入銀行名稱",
     "yhzh":"銀行帳號",
     "qsryhzh":"請輸入銀行帳號",
     "gjhkdm":"國際匯款代碼",
     "qsrgjhkdm":"請輸入國際匯款代碼",
     "yhdz":"銀行地址",
     "qsryhdz":"請輸入銀行地址",
     "skrxm":"收款人姓名",
     "qsrskrxm":"請輸入收款人姓名",
     "skrdh":"收款人電話",
     "qsrskrdh":"請輸入收款人電話",
     "skrdz":"收款人地址",
     "qsrskrdz":"請輸入收款人地址",
     "tbjl":"提幣記錄",
     "fzcg":"複製成功",
     "aqzx":"安全中心",
     "yxrz":"信箱認證",
     "ybd":"已綁定",
     "wbd":"未綁定",
     "yrz":"已認證",
     "wrz":"未認證",
     "ts":"為保護您的帳戶，建議綁定信箱",
     "qsryxdz":"請輸入郵件地址",
     "dlmm":"登入密碼",
     "mbwtsz":"密保問題設定",
     "mbwt":"密保問題",
     "qtxda":"請填答案",
     "zyts":"重要提示：",
     "zytsCont":"請勿洩漏密保答案和驗證碼，並牢記密保問題，這將有助於您找回密碼",
     "qsrxmm":"請輸入新密碼",
     "sydqmmcz":"使用目前密碼重設",
     "zhmm":"密保問題找回密碼",
     "ysz":"已設定",
     "tg":"跳過",
     "qsrdlmm":"請輸入登入密碼",
     "bzxz":"選擇",
     "zwsj":"暫無資料",
     "qd":"確定",
     "zsgd":"展示更多",
     "zdss":"最低手數",
     "mnjy":"模擬交易",
     "sx":"篩選",
     },
     "zb":{
     "tgdd":"AI託管訂單",
     "tgz":"託管中",
     "ysh":"已贖回",
     "shz":"贖回中",
     "zq":"週期：",
     "tian":"天",
     "syl2":"收益率：",
     "rgjg":"認購價格：",
     "rgjg2":"認購價格",
     "xdsj":"下單時間：",
     "yhl":"已獲利：",
     "syts":"剩餘天數：",
     "sh":"贖回",
     "syl":"收益率",
     "bz":"名稱",
     "dl":"兌率",
     "tgts":"託管天數：",
     "tgsl":"託管數量",
     "qsrtgsl":"請輸入託管數量",
     "dbxe":"單筆限額 ",
     "ljtg":"立即託管",
     "zztg":"已申購金額",
     "yjjrsy":"預計今日收益",
     "ljsy":"累計收益",
     "tgzdd":"託管中訂單",
     "ljzc":"立即轉入",
     "gz":"規則",
     "cpzq":"產品週期",
     "gm":"購買",
     "ts":"提示",
     "shts":"您正在進行贖回操作,未到期贖回將損失 5%.確定贖回嗎?",
     "xgcs":"限購次數",
     },
     "dk":{
     "dk":"貸款",
     "dkzh":"貸款帳戶",
     "yzsf":"驗證您的身分並獲得更多貸款金額！",
     "ksyz":"開始驗證",
     "wxj":"我想藉...",
     "dkqx":"貸款期間（天）：",
     "mrll":"每日利率：",
     "lxze":"利息總額：",
     "dkts":"貸款3天內無須支付利息,之後即可支付利息",
     "xzj":"現在藉",
     "wyydbzx":"同意",
     "dkfwxy":"《貸款服務協議》",
     "dkfwxy2":"貸款服務協議",
     "dkysxy":"《貸款隱私協議》",
     "dkjl":"貸款記錄",
     "hth":"合約編號",
     "yfk":"已放款",
     "lx":"利息：",
     "zhke":"總還款金額：",
     "znj":"滯納金：",
     "znjl":"滯納金率：",
     "yqts":"逾期天數：",
     "qhk":"去還款",
     "tpsc":"信用貸款(圖片上傳)",
     "fwxx":"房屋資訊",
     "srzm":"收入證明(僱傭關係)",
     "yhmx":"銀行明細",
     "zjz":"證件照",
     "ljdk":"立即貸款",
     "xm":"姓名",
     "ndxm":"您的姓名",
     "qsrndxm":"請輸入您的姓名",
     "gj":"國家",
     "ndgj":"您的國家",
     "qsrndgj":"請輸入您的國家",
     "dz":"地址",
     "nddz":"您的地址",
     "qsrnddz":"請輸入您的地址",
     "csrq":"出生日期",
     "ndcsrq":"您的出生日期",
     "qsrndcsrq":"請輸入您的出生日期",
     "dhhm":"電話",
     "nddhhm":"您的電話號碼",
     "qsrnddhhm":"請輸入您的電話號碼",
     "zj":"證件",
     "sfzm":"身份正面",
     "qscsfzm":"請上傳身分正面",
     "sffm":"身份反面",
     "qscsffm":"請上傳身分反面",
     "ddqr":"訂單確認",
     "jk":"借款：",
     "dkqx2":"貸款期間：",
     "qrxd":"確認下單",
     "yhkxq":"應還款詳情",
     "hkqr":"還款確認",
     "yhk":"應還款：",
     "jksj":"借款時間：",
     "ljhk":"立即還款",
     },
     "jy":{
       "rq":"日期",
       "qqjy":"選擇權記錄",
     "hyjy":"合約交易",
     "qqhy":"選擇權合約",
     "dqwt":"委託",
     'wtz':"委託中",
     "hyjl":"合約紀錄",
     "shou":"手",
     "dk":"開：",
     "zhjg":"最後價格：",
     "jyfy":"交易費用：",
     "kfsj":"開放時間：",
     "gg":"槓桿：",
     "pl":"批量：",
     "kpj":"開盤價：",
     "yk":"盈虧：",
     "cd":"撤單",
     "jsj":"結算價：",
     "fx":"方向：",
     "jgsj":"交割時間：",
     "gb":"關閉",
     "jxxd":"繼續下單",
     "xj":"限價：",
     "gm":"購買：",
     "sl":"數量",
     "fy":"費用：",
     "tzbzj":"調整保證金",
     "zyzs":"止盈止損",
     "pc":"平倉",
     "mr":"買入",
     "zjbzj":"增加保證金",
     "jsbzj":"減少保證金",
     "yxhy":"合約交易：",
     "cc":"持倉(張)：",
     "cc2":"持倉",
     "cwbzk":"倉位保證金：",
     "zdzjbzj":"最多增加保證金：",
     "zjbzj2":"增加保證金：",
     "qsrzbzj":"請輸入保證金",
     "yxhy2":"永續合約",
     "kp":"可平",
     "zhang":"張",
     "xj2":"限價",
     "zy":"止盈",
     "zs":"停損",
     "ssjyzl":"搜尋交易種類",
     "ddb":"成交量",
     "di":"低：",
     "gao":"高：",
     "gb2":"關：",
     "fz":"分鐘",
     "mai":"買：",
     "zhang2":"漲",
     "tie":"跌",
     "sy":"收益",
     "kz":"看漲",
     "kt":"看跌",
     "bndy":"不能低於 ",
     "sxbzj":"所需保證金：",
     "ky":"可用：",
     "sj":"市價",
     "mc":"賣出",
     "zxtzsl":"最低數量 ",
     "min":"最少數量 ",
     "max":"最大數量 ",
     "yebz":"餘額不足",
     "ddz":"等待中",
     "wtzl":"委託總量：",
     "wtjg":"委託價格：",
     "ycd":"已取消訂單",
     "lswt":"合約紀錄",
     "qsrzyjg":"請輸入止盈價格",
     "qsrzsjg":"請輸入停損價格",
     "ccsl":"持倉數量：",
     "ccjg":"持倉價格：",
     "ggbs":"槓桿倍數：",
     "zy2":"止盈：",
     "zs2":"停損：",
     "zje":"總金額：",
     "ss":"手數：",
     "kcjg":"開倉價格：",
     "bzjl":"保證金：",
     "lscc":"歷史持倉",
     "gmj":"購買價：",
     "guadan":"掛單",
     "dqjg":"當前價格：",
     "gdjg":"掛單價格：",
     "pcjg":"平倉價格：",
     "ccsj":"持倉時間：",
     "gdsj":"掛單時間：",
     "pcsj":"平倉時間：",
     "fdjyk":"浮動淨損虧",
     "pcsl":"平倉數量",
     "qrpc":"確認平倉",
     "ypc":"已平倉",
     "ss2":"手數",
     "qsrss":"請輸入手數"
     },
     "gjrz":{
     "sfyz":"KYC認證",
     "t1":"1、支援小於8M的JPG、JPEG或PNG格式圖片。",
     "t2":"2、證件照要求清晰，不允許任何修改和遮擋，必須看清人像，證件號碼和姓名。",
     "t3":"3、照片需免冠，建議未化妝，手持證件人的五官清晰可鑑，完整需露出手臂。",
     "t4":"確定",
     "bh":"駁回",
     "shz":"審核中",
     "shtg":"審核通過",
     "nyrzcg":"您已認證成功",
     "sczjz":"上傳證件照",
     "sczjzmz":"上傳證件正面照",
     "sczjbmz":"上傳證件背面照",
     "scgrqmz":"上傳手持證件照",
     "gjlb":"國家列表",
     "qxzgjlb":"請選擇國家",
     "zsxm":"真名",
     "qsrzsxm":"請輸入真實姓名",
     "zjlx":"證件類型",
     "zjhm":"證件號碼",
     "qsrzjhm":"請輸入證件號碼",
     "khh":"開戶行",
     "qsrkhh":"請輸入開戶行",
     "yhkh":"銀行卡號",
     "qsryhkh":"請輸入銀行卡號碼",
     },
     "status":{
     "statusText":['失敗','等待處理','成功'],
     },
     "download":{
     "t1":"行動交易，隨時隨地",
     "xz":"下載"
     },
     "langNew":{
       "jmm": "舊密碼",
       "qsrjmm": "請輸入舊密碼",
       "szhb": "數字貨幣",
       "gjs": "貴金屬",
       "ny": "能源",
       "yy": "原油",
       "jy": "交易",
       "jmhb": "加密貨幣",
       "yxhy": "永續合約",
       "gdjy": "掛單交易",
       "khh": "開戶行",
       "qsrkhh": "請輸入開戶行",
       "yhkh": "銀行卡號",
       "qsryhkh": "請輸入銀行卡號",
     "mnzh":"模擬帳號",
     "zjjypt":"最佳交易平台",
     "brjmzndxq":"本軟體以最佳技術專業滿足您的所有需求",
     "jx":"繼續",
     "yssm":"隱私權聲明",
     "fxqzc":"反洗錢政策",
     "jgxkz":"監管許可證",
     "ckgd":"看更多",
     "gd":"更多",
     "dd":"訂單",
     "ckdd":"查看訂單",
     "yxdd":"永續訂單",
     "qqdd":"選擇權訂單",
     "hand":"1手 =",
     "lxwm":"聯絡我們",
     "tpfzl":"將您的影像放在這裡,或",
     "liulang":"瀏覽",
     "zctpgs":"支援: JPG、JPEG2000、PNG",
     "ysr":"月收入",
     "ndysr":"您的月收入",
     "qsrndysr":"請輸入您的月收入",
     "yqtzje":"預期投資金額",
     "qsrtzje":"請輸入預期投資金額",
     "zszh":"真實帳號",
     "qdl":"請登入",
     "zx":"自選",
     "hkdz":"還款地址",
     "dkje":"貸款金額：",
     "zlx":"總利息：",
     "hkze":"還款總額：",
     "qcz":"去儲值",
     "yebz":"您的餘額不足，請儲值",
     "dhje":"待還金額：",
     "hkjl":"還款記錄：",
     "hkje":"還款金額：",
     "kyye":"可用餘額：",
     "qb": '全部',
     "lmc": "鏈名稱：",
     "search": "搜尋",
     "mrjg":"買入價",
     "lxkf":"聯絡客服",
     "wyj":"違約金",
     "yxsj":"運行時間：",
     "jssj":"結束時間：",
     "hksj":"還款時間：",
     "sysj":"剩餘時間：",
     "jkqx":"借款期限：",
     "yq":"逾期：",
     "qqss":"您的選擇權交易訂單已過期，您的損失為",
     "qqlr":"您的選擇權交易訂單已過期，您的利潤為",
     "bz":"幣種",
     "dzje":"到帳金額",
     "lxyxzc":"郵箱聯絡支持",
     },
     "langNew9":{
      "dzje":"交易品種市場趨勢",
      "lxyxzc":"開啟您的數位交易歷程",
      "text1":"從建立帳號開始",
      "text2":"邀請好友加入MFTG一起玩",
      "text3":"進行帳戶儲值",
      "text4":"支援多種幣種儲值，讓您快速開啟交易",
      "text5":"開始交易",
      "text6":"提供多種優質交易對選擇，在MFTG暢快交易",
      "text7":"邀請好友賺USDT",
      "text8":"邀請好友輕鬆賺取USDT",
      "text9":"貸款功能上線",
      "text10":"當您沒錢的時候,您可以申請貸款,最快當天下發",
      "text11":"交易所有資產",
      "text12":"外匯、加密貨幣、期貨、ETF等等",
      },
      "bank":{
        "text1":"您最信賴的理財平台",
        "text2":"即時新聞快訊",
        "text3":"了解金融業即時資訊",
        "text4":"開始了解",
        "text5":"新聞快訊",
        "text6":"選擇銀行",
        "text7":"金融卡",
        "text8":"金額...",
        "text9":"新增銀行卡",
        "text10":"銀行帳戶",
        "text11":"請輸入銀行帳戶",
        "text12":"卡號ID",
        "text13":"請輸入卡號ID",
        "text14":"銀行國際代碼",
        "text15":"请输入国际代码",
        "text16":"請輸入電話號碼",
        "text17":"添加",
        "text18":"刪除銀行卡",
        "text19":"實際到帳",
        "text20":"提現信息",
        "text21":"選擇銀行卡",
        "text22":"注意事項",
        "text23":"最低提幣數量：",
        "text24":"小於最低提幣數量不能進行提幣",
        "text25":"• 為保障資金安全，當您帳戶安全策略變更、密碼修改、我們會對提幣進行人工審核，請耐心等待工作人員電話或郵件聯繫。",
        "text26":"• 請務必確認電腦及瀏覽器安全，防止資訊被竄改或外洩。",
        "text27":"• 您所提的USD，每次操作均意味著您所擁有的該提幣頁面所顯示的資產總量減少相應的提出數量。",
        "text28":"提現紀錄",
        "text29":"法幣類型",
      },
      "team":{
        "tdjs":"團隊介紹",
        "wmdtd":"我們的團隊",
        "tdjj":"我們為交易者提供更低的交易成本、更好的訂單執行和更安全的金融服務。加入國際級的交易經紀商，讓您輕鬆參與全球金融市場。",
        "gltdjs":"管理團隊介紹",
        "mc0":"克里斯蒂安·詹姆斯·奧拉姆",
        "mc1":"阿里·柯恩",
        "mc2":"戴維·查爾斯·哈里森",
        "mc3":"大衛·哈丁",
        "mc4":"馬庫斯·約翰·費舍爾",
        "mc5":"迈克尔·莱文",
        "mc6":"羅賓·馬修斯",
        "mc7":"薩蒂亞·賴托",
        "zc0":"執行長(CEO)",
        "zc1":"首席技術長",
        "zc2":"財務長(CFO)",
        "zc3":"法律顧問",
        "zc4":"營運長(COO)",
        "zc5":"首席投資長(CIO)",
        "zc6":"首席信貸官",
        "zc7":"數據與人工智慧總監",
        "text01":"安全性和透明性",
        "text02":"我們始終關注用戶資產安全",
        "text03":"多國監管牌照",
        "text04":"資產保護協議",
        "text05":"三方獨立審計",
        "text06":"最優質的交易條件",
        "text07":"極致交易體驗",
        "text08":"多種交易工具支持",
        "text09":"高效率的訂單執行",
        "text10":"專業的K線數據",
        "text11":"準備好和我們一起開始您的職業生涯了嗎?",
        "ljks":"立即開始",
        "技术副总裁":"技術副總裁",
        "公共关系与对外事务总监":"公共關係與對外事務總監",
        "首席战略官":"首席戰略官",
        "首席人工智能科学家":"首席人工智能科學家",
        "首席风险官":"首席風險官",
      },
      "aiDetail":{
        "syxq":"收益詳情",
        "zsy":"總收益",
        "rq":"日期",
      },
      kdkje: '可貸款金額'
     // "langNew2":{
     //   "sy":"首頁",
     //   "sc":"市場",
     //   "sclb":"市場列表",
     //   "jy":"交易",
     //   "zh":"帳戶",
     //   "db":"貸幣",
     //   "zchm":"註冊號碼",
     //   "cp":"產品",
     //   "tzjd":"投資借貸",
     //   "zxzc":"線上支援",
     //   "xd":"下單",
     //   "zzjptgmnr":"投資未來，在公平開放的金融體系中增加您的投資組合。",
     //   "yy":"應用程式",
     //   "pqnr":"摒棄傳統規則的行動銀行，為您提供精確的財務管理工具。",
     //   "jiami":"加密",
     //   "tgnr":"透過使用加密貨幣進行存款，可以獲得額外的安全層，並確保快速交易處理。",
     //   "jyl":"平均24小時成交量",
     //   "ssjmhb":"上市加密貨幣",
     //   "zchy":"註冊用戶",
     //   "djxz":"點下載",
     //   "azsc":"安卓市場",
     //   "pgsd":"蘋果商店",
     //   "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
     // }
}



// WEBPACK FOOTER //
// ./src/lang/tw.js